/**
 * C 端用户登录/注册页
 * 支持邀请码注册和已有账号登录
 */
import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import userAuthService from '../../services/userAuthService';
import '../../styles/LoginPage.css';

function UserLoginPage() {
  const [mode, setMode] = useState('login'); // 'login' | 'register'
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [inviteCode, setInviteCode] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname
    || sessionStorage.getItem('login_redirect')
    || '/';

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      if (mode === 'register') {
        await userAuthService.register(username, password, inviteCode);
      } else {
        await userAuthService.login(username, password);
      }
      sessionStorage.removeItem('login_redirect');
      navigate(from, { replace: true });
    } catch (err) {
      const msg = err.response?.data?.detail || '操作失败，请重试';
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <div className="login-header">
          <h1>AI互动世界</h1>
          <p>{mode === 'login' ? '登录账号' : '邀请注册'}</p>
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          <div className="input-group">
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="用户名"
              className="password-input"
              disabled={loading}
              autoFocus
            />
          </div>
          <div className="input-group">
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="密码"
              className="password-input"
              disabled={loading}
            />
          </div>
          {mode === 'register' && (
            <div className="input-group">
              <input
                type="text"
                value={inviteCode}
                onChange={(e) => setInviteCode(e.target.value.toUpperCase())}
                placeholder="邀请码（格式：XXXX-XXXX-XXXX）"
                className="password-input"
                disabled={loading}
              />
            </div>
          )}

          {error && <div className="error-message">⚠️ {error}</div>}

          <button
            type="submit"
            className="login-button"
            disabled={loading || !username || !password || (mode === 'register' && !inviteCode)}
          >
            {loading ? '处理中...' : mode === 'login' ? '登录' : '注册'}
          </button>
        </form>

        <div className="login-footer">
          {mode === 'login' ? (
            <p className="tip">
              没有账号？{' '}
              <button className="link-btn" onClick={() => { setMode('register'); setError(''); }}>
                使用邀请码注册
              </button>
            </p>
          ) : (
            <p className="tip">
              已有账号？{' '}
              <button className="link-btn" onClick={() => { setMode('login'); setError(''); }}>
                直接登录
              </button>
            </p>
          )}
        </div>
      </div>
      <p className="page-copyright">版权所有 © 2026 北京流动矩阵科技有限公司。保留所有权利。</p>
    </div>
  );
}

export default UserLoginPage;
